const doc = [({"false":null, "no":({"activerecord":({"models":({"api_maker_table/table_search":({})}), "attributes":({"api_maker_table/table_search":({})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;